import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { findLocation } from "../../store/locationShow/actions/findLocation";
import { findMessages } from "../../store/locationShow/actions/findMessages";
import { findUserRoles } from "../../store/locationShow/actions/findUserRoles";
import { HeaderSection } from "./components/HeaderSection";
import { LoadingSection } from "./components/LoadingSection";
import { SegmentsSection } from "./components/SegmentsSection";

export const LocationShow: React.FC = () => {
  const dispatch = useDispatch();

  const { id }: { id: string } = useParams();

  useEffect(() => {
    dispatch(findLocation(id));
    dispatch(findUserRoles(id));
    dispatch(findMessages(id));
  }, [dispatch, id]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/tic/instalaciones" />
          </IonButtons>
          <IonTitle>Instalación</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <LoadingSection />
        <HeaderSection />
        <SegmentsSection />
      </IonContent>
    </IonPage>
  );
};
